import { AbstractControl, FormGroup } from '@angular/forms';

export type FieldLabels = Record<string, string>;

const ERROR_MSGS: Record<string, (e: any, label: string) => string> = {
  required: (_e, label) => `“${label}” es obligatorio.`,
  minlength: (e, label) =>
    `“${label}” debe tener al menos ${e.requiredLength} caracteres (actual: ${e.actualLength}).`,
  maxlength: (e, label) =>
    `“${label}” no puede superar ${e.requiredLength} caracteres (actual: ${e.actualLength}).`,
  email: (_e, label) => `“${label}” no es un email válido.`,
  pattern: (_e, label) => `“${label}” tiene un formato inválido.`,
  min: (e, label) => `“${label}” debe ser ≥ ${e.min}.`,
  max: (e, label) => `“${label}” debe ser ≤ ${e.max}.`,
  requiredTrue: (_e, label) => `Debes aceptar “${label}”.`,
};

/** Mensajes para un control */
export function getControlMessages(
  ctrl: AbstractControl | null,
  name: string,
  labels?: FieldLabels
): string[] {
  if (!ctrl || !ctrl.errors) return [];
  const label = labels?.[name] ?? name;
  const msgs: string[] = [];

  Object.entries(ctrl.errors).forEach(([key, val]) => {
    const fmt = ERROR_MSGS[key];
    if (fmt) msgs.push(fmt(val, label));
    else msgs.push(`“${label}” no es válido.`);
  });

  return msgs;
}

/** Recorre el formulario (soporta anidados) y retorna todas las alertas */
export function collectFormMessages(
  form: FormGroup,
  labels?: FieldLabels,
  parentKey = ''
): string[] {
  const out: string[] = [];
  Object.keys(form.controls).forEach((key) => {
    const ctrl = form.get(key)!;
    const path = parentKey ? `${parentKey}.${key}` : key;
    if ((ctrl as any).controls) {
      // FormGroup o FormArray
      if (ctrl instanceof FormGroup) {
        out.push(...collectFormMessages(ctrl, labels, path));
      } else {
        // FormArray
        const arr: AbstractControl[] = (ctrl as any).controls ?? [];
        arr.forEach((c, i) => {
          if ((c as any).controls) {
            out.push(
              ...collectFormMessages(c as FormGroup, labels, `${path}[${i}]`)
            );
          } else {
            out.push(...getControlMessages(c, `${path}[${i}]`, labels));
          }
        });
      }
    } else {
      out.push(...getControlMessages(ctrl, key, labels));
    }
  });
  return out;
}

/** Devuelve el primer nombre de control inválido (plano) para enfocar en template */
export function firstInvalidControlName(form: FormGroup): string | null {
  const keys = Object.keys(form.controls);
  for (const k of keys) {
    const c = form.get(k)!;
    if (c.invalid) return k;
  }
  return null;
}
